import React, { useState, useRef } from "react";
import LinkButton from "./LinkButton";
import SearchIcon from "../../images/SearchIcon.svg";
import clearTextIconBlue from "../../images/clearTextBlue.svg";
import { ClickAwayListener } from "@mui/material";
import "./RoundedSearchTextField.scss";

const SearchBannersTextfield = ({
  placeholder = "Search...",
  onTextChange,
  handleSearch,
  expandable,
  setIsSearchBarEmpty,
  isSearchBarEmpty,
}) => {
  const [inputValue, setInputValue] = useState("");
  const searchButtonRef = useRef("");
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    setInputValue("");
    onTextChange("");
    setIsSearchBarEmpty(true);
    setIsFocused(false);
  };
  const clearTextField = () => {
    const element = document.getElementById("tf-search-field");
    if (element) {
      element.value = "";
      setInputValue("");
      setIsSearchBarEmpty(true);
      onTextChange(element.value);
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch(event);
    }
  };
  const handleSearchClick = (event) => {
    handleSearch(event);
  };
  return (
    <div
      className={`tf-rounded-search ${expandable ? "expandable" : ""} ${
        isFocused ? "focused" : ""
      }`}
    >
      <ClickAwayListener onClickAway={handleBlur}>
        <div className="d-flex align-items-center">
          <img src={SearchIcon} alt="" className="search-icon" />
          <input
            id="tf-search-field"
            type="text"
            value={inputValue || ""}
            placeholder={placeholder}
            onFocus={handleFocus}
            className="search-input"
            autoComplete="off"
            onKeyPress={handleKeyPress}
            onDrop={(e) => e.preventDefault()}
            onChange={(e) => {
              if (e.target.value?.trim().length > 0) {
                setInputValue(e.target.value);
                setIsSearchBarEmpty(false);
              } else {
                setIsSearchBarEmpty(true);
                setInputValue("");
              }
              onTextChange(e.target.value);
            }}
          />

          {isFocused && (
            <LinkButton
              ref={searchButtonRef}
              className=""
              handleClick={(event) => {
                handleSearchClick(event);
              }}
              disabled={isSearchBarEmpty}
              title="SEARCH"
              height="32px"
            />
          )}

          {isFocused && (
            <img
              src={clearTextIconBlue}
              alt="Clear text"
              className=""
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (inputValue.length > 0) {
                  clearTextField();
                } else {
                  handleBlur();
                }
              }}
            />
          )}
        </div>
      </ClickAwayListener>
    </div>
  );
};

export default SearchBannersTextfield;
